import React, { useState, useEffect, useContext } from "react";
import Cookies from "js-cookie";
import SeoRoutesContext from "../../../components/shared/SeoRoutesContext";
import { useParams } from "react-router-dom";
import {
  Grid,
  Box,
  Typography,
  Chip,
  Container,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import ServicioDetailCover from "../../../assets/images/ServicioDetailCover.png";
import FaqSectionFigmaBg from "../../../assets/images/FaqSectionFigmaBg.svg";
import { ServiceCardSmall } from "../../../components/ServiceCardSmall";
import HeaderFrontOffice from "../../../components/FrontOfficeHeaders/HeaderFrontOffice";
import { FrontOfficeFooter } from "../../../components/FrontOfficeFooter";
import { TraduccionesContext } from "components/shared/TraduccionesContext";
import { Helmet } from "react-helmet";
import { ContactForm } from "../../../components/ContactForm";
import LoadingScreen from "components/LoadingScreen";
import { useLocation } from "react-router-dom";

function ServiciosDetailPage() {
  const { pathname } = useLocation();
  const [seoParams, setSeoParams] = React.useState(null);
  const [serviceId, setserviceId] = React.useState(null);
  const { traducciones, loading, setLoading, idioma, idiomas } = useContext(TraduccionesContext);
  const seoRoutes = useContext(SeoRoutesContext);
  // const { id: serviceId } = useParams();
  const [services, setServices] = useState([]);
  const [currentServiceLangChanged, setcurrentServiceLangChanged] = useState(null);
  const [currentService, setCurrentService] = useState(null);
  const [expandedFaq, setExpandedFaq] = useState(null);
  const [testimonios, setTestimonios] = useState([]);
  const [testimonioIdx, setTestimonioIdx] = useState(0);
  const navigateTo = (routeKey, seoRoutes, lang) => {
    let path = "";
    const seoEntry = seoRoutes.find(
      (seo) =>
        seo.PAGE.replaceAll(".aspx", "").toLowerCase() === routeKey.toLowerCase() &&
        seo.ACRONIMO_ISO === lang
    );
    if (seoEntry) {
      path = `/${seoEntry.ACRONIMO_ISO}/${seoEntry.SEO_URL_FRIENDLY}`;
    } else {
      path = routeKey;
    }
    path = path.replace("//", "/");
    return path;
  };

  const handleNavigation = (key) => {
    const pathSegments = location.pathname.split("/").filter(Boolean);
    const lang = pathSegments[0] || "es"; // Asumir "es" como idioma por defecto si no se encuentra ninguno
    Cookies.set("lang", lang, { expires: 7 });
    const path = navigateTo(key, seoRoutes, lang);
    return path; // Not typically needed unless you have other uses for path after navigation
  };

  // Función para cargar los servicios
  const cargarServicios = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/services/list/${idioma}`,
        {
          method: "GET",
        }
      );
      const data = await response.json();
      setLoading(false);
      setServices(
        data.response.data
          .filter((item) => item.active)
          .sort((a, b) => a.pos - b.pos)
          .map((item) => ({
            title: item.title,
            url: `${window.location.pathname.split("/").filter((segment) => segment !== "")[0]}/${
              item.seoURLFriendly
            }/`,
            // url: `${pathname.substring(0, pathname.lastIndexOf("/"))}/${item.seoURLFriendly}`,
            seoURLFriendly: item.seoURLFriendly,
            // url: `${handleNavigation("servicios")}/${item.id}/${item.seoURLFriendly}`,
          }))
      );

      // Simulamos encontrar un servicio
      // Primero, obtenemos la URL y dividimos en segmentos
      let pathSegments = window.location.pathname.split("/").filter((segment) => segment !== "");

      // Luego, obtenemos el último segmento no vacío
      let seoUrl = pathSegments.pop();

      seoUrl = decodeURIComponent(seoUrl);
      let serviceIt = data.response.data.find(
        (item) => item.active && decodeURIComponent(item.seoURLFriendly) === seoUrl
      );
      if (serviceIt) {
        setserviceId(serviceIt.id);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data: ", error);
    }
  };

  // Función para cargar los detalles de un servicio específico
  const cargarServicio = async () => {
    if (!serviceId) return; // Asegúrate de tener un serviceId válido

    // Tipos de bloque que pertenecen a la plantilla (metodología, beneficios, FAQ).
    // Se define aquí para que esté disponible en ambos fetch (idioma principal y alternativo).
    const plantillaTipos = ["metodologia", "beneficio", "faq"];

    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/services/detail/${serviceId}/${idioma}`,
        {
          method: "GET",
        }
      );
      const data = await response.json();
      setLoading(false);
      console.log(data.response.data);
      var LangItem = idiomas.filter((item) => item.id == idioma)[0];

      // Combinar sections y plantillaBlocks por si el backend no recompila aún,
      // y filtrar por tipo en el frontend para garantizar el comportamiento correcto.
      const rawSections = data.response.data.sections || [];
      const rawPlantilla = data.response.data.plantillaBlocks || [];
      const allBlocks = [...rawSections, ...rawPlantilla];
      const contenidoSections = allBlocks
        .filter((s) => !s.tipo || !plantillaTipos.includes(s.tipo))
        .sort((a, b) => a.pos - b.pos);
      const plantillaBlocks = allBlocks
        .filter((s) => plantillaTipos.includes(s.tipo))
        .sort((a, b) => a.pos - b.pos);

      // Testimonios: el API solo los devuelve si el servicio tiene "showTestimonials"; compatibilidad si viniera el flag en false con lista antigua.
      if (data.response.data.showTestimonials === false) {
        setTestimonios([]);
      } else if (data.response.data.testimonios?.length) {
        setTestimonios(data.response.data.testimonios);
        setTestimonioIdx(0);
      } else {
        setTestimonios([]);
      }

      setCurrentService({
        ...data.response.data,
        sections: contenidoSections,
        keys: data.response.data.keys.sort((a, b) => a.pos - b.pos),
        plantillaBlocks,
        fullurl:
          location.origin +
          "/" +
          LangItem.label.toLowerCase() +
          "/" +
          data.response.data.seoURLFriendly,
        iso: LangItem.label.toLowerCase(),
      });
      setSeoParams({
        title: data.response.data.seoTitle || "ALTH LOAN",
        keyword: data.response.data.seoMetaKeyword || "",
        description: data.response.data.seoMetaDescription || "",
      });
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data: ", error);
    }

    try {
      var otherLangItem = idiomas.filter((item) => item.id != idioma)[0];
      var otherLang = otherLangItem.id;
      fetch(`${process.env.REACT_APP_API_BASE_URL}/services/detail/${serviceId}/${otherLang}`, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((data) => {
          const rawSectionsLang = data.response.data.sections || [];
          const rawPlantillaLang = data.response.data.plantillaBlocks || [];
          const allBlocksLang = [...rawSectionsLang, ...rawPlantillaLang];
          const contenidoSectionsLang = allBlocksLang
            .filter((s) => !s.tipo || !plantillaTipos.includes(s.tipo))
            .sort((a, b) => a.pos - b.pos);
          const plantillaBlocksLang = allBlocksLang
            .filter((s) => plantillaTipos.includes(s.tipo))
            .sort((a, b) => a.pos - b.pos);

          setcurrentServiceLangChanged({
            ...data.response.data,
            sections: contenidoSectionsLang,
            keys: data.response.data.keys.sort((a, b) => a.pos - b.pos),
            plantillaBlocks: plantillaBlocksLang,
            fullurl:
              location.origin +
              "/" +
              otherLangItem.label.toLowerCase() +
              "/" +
              data.response.data.seoURLFriendly,
            iso: otherLangItem.label.toLowerCase(),
          });
        })
        .catch(() => {
          setcurrentServiceLangChanged(null);
        });
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  // Efecto para cargar servicios cuando cambia el idioma
  useEffect(() => {
    if (idioma) {
      cargarServicios();
    }
  }, [idioma, pathname]);

  // Efecto para cargar detalles del servicio cuando cambian idioma o serviceId
  useEffect(() => {
    if (serviceId && idioma) {
      cargarServicio();
    }
  }, [serviceId, idioma]);

  // Al cargar currentService, abre el primer ítem del FAQ por defecto
  useEffect(() => {
    if (!currentService) return;
    const firstFaq = (currentService.plantillaBlocks || [])
      .filter((b) => b.tipo === "faq")
      .sort((a, b) => a.pos - b.pos)
      .slice(1)[0]; // slice(1) omite la cabecera, igual que en el render
    if (firstFaq) {
      setExpandedFaq(firstFaq.id ?? firstFaq.pos);
    }
  }, [currentService]);

  // Autoplay del carrusel de testimonios (avanza cada 5 s si hay más de 3)
  const TESTIMONIOS_AUTOPLAY_MS = 5000;
  useEffect(() => {
    if (testimonios.length <= 3) return;
    const total = testimonios.length;
    const id = setInterval(() => {
      setTestimonioIdx((prev) => (prev + 1) % total);
    }, TESTIMONIOS_AUTOPLAY_MS);
    return () => clearInterval(id);
  }, [testimonios.length]);

  if (!currentService) {
    return <LoadingScreen />;
  }

  /**
   * Normaliza títulos y slugs de servicios para filtrar los cuadros visibles.
   * Entrada: texto de título o `seoURLFriendly` recibido desde el API.
   * Salida: texto en minúsculas, sin acentos ni símbolos duplicados.
   * Casos límite: valores nulos o vacíos devuelven cadena vacía.
   * Seguridad: no interpreta HTML ni ejecuta contenido externo; solo transforma texto para comparación.
   */
  const normalizeServiceName = (value = "") =>
    value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim();

  const visibleServiceNames = new Set([
    "recobro amistoso",
    "recobro judicial",
    "defensa juridica para entidades financieras",
    "compra de carteras npl",
    "servicios para inversores",
    "back office juridico",
    "back office juridica",
  ]);

  const visibleServices = services.filter((service) => {
    const normalizedTitle = normalizeServiceName(service.title);
    const normalizedSlug = normalizeServiceName(service.seoURLFriendly);

    return visibleServiceNames.has(normalizedTitle) || visibleServiceNames.has(normalizedSlug);
  });

  return (
    <>
      {seoParams && currentService && (
        <Helmet>
          <title>{seoParams.title}</title>
          <meta name="description" content={seoParams.description} />
          <meta name="keywords" content={seoParams.keyword} />
          <link rel="canonical" href={currentService.fullurl} />
          <meta property="og:title" content={seoParams.title} />
          <meta property="og:description" content={seoParams.description || ""} />
          <meta property="og:image" content={currentService.image || ""} />
          <meta property="og:url" content={currentService.fullurl} />
          <meta property="og:type" content="website" />
          <meta property="article:author" content="ALTHLOAN" />
          <link rel="alternate" hrefLang={currentService.iso} href={currentService.fullurl} />
          {currentServiceLangChanged?.fullurl && currentServiceLangChanged?.iso ? (
            <link
              rel="alternate"
              hrefLang={currentServiceLangChanged.iso}
              href={currentServiceLangChanged.fullurl}
            />
          ) : null}
        </Helmet>
      )}
      <Box>
        <HeaderFrontOffice
          keySelected="servicios"
          currentPage="serviciosDetail"
          urlLangChanged={currentServiceLangChanged?.seoURLFriendly ?? ""}
        />
      </Box>
      <Box
        sx={{
          marginTop: "64px",
          height: "577px",
          backgroundImage: `url("${
            currentService && currentService.image ? currentService.image : ServicioDetailCover
          }")`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          color: "#FFF",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "& *": { fontFamily: "Nunito !important" },
        }}
      >
        <Container sx={{ paddingY: "3rem" }}>
          <Box>
            <Typography fontSize="48px" fontWeight={"bold"} textAlign={"center"} component={"h1"}>
              {currentService && currentService.title}
            </Typography>
            <Typography fontSize="18px" textAlign={"center"}>
              {currentService && currentService.subtitle}
            </Typography>
          </Box>
        </Container>
      </Box>
      <Box sx={{ background: "#FFF", color: "#222", "& *": { fontFamily: "Nunito !important" } }}>
        <Container
          sx={{
            paddingTop: "77px",
            paddingBottom: "72px",
            background: "#FFF",
            maxWidth: {
              xl: "1320px!important", // max-width 1320px para xl
              lg: "1140px!important", // max-width 1140px para lg
              md: "100%!important", // max-width 100% para md
              sm: "100%!important", // max-width 100% para sm
              xs: "100%!important", // max-width 100% para xs
            },
          }}
        >
          {/* Mismo margen horizontal que la sección Metodología (padding del Box gris). */}
          <Box
            sx={{
              paddingX: { xs: "1rem", md: "2.6rem" },
              boxSizing: "border-box",
              width: "100%",
            }}
          >
            <Typography fontSize="40px" fontWeight={"bold"} textAlign={"center"} component={"h2"}>
              {currentService && currentService.sections[0] && currentService.sections[0].title}
            </Typography>
            <Typography fontSize="16px" textAlign={"center"} marginBottom={"2rem"}>
              {currentService && currentService.sections[0] && currentService.sections[0].subtitle}
            </Typography>
            {currentService &&
              currentService.sections &&
              currentService.sections.length > 1 &&
              currentService.sections
                .filter((section) => section.active)
                .map((section, index) => (
                  <>
                    {index % 2 !== 0 && index > 0 && (
                      <Grid
                        container
                        sx={{
                          marginTop: { xs: "1rem", sm: "1rem", md: "3rem", lg: "3rem", xl: "3rem" },
                        }}
                      >
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={6}
                          lg={6}
                          xl={6}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            // En desktop la imagen va a la izquierda de la fila: alinear al inicio evita
                            // el hueco extra que deja justifyContent center respecto al borde del bloque.
                            justifyContent: { xs: "center", md: "flex-start" },
                            // Cede ancho a la columna de texto; a mayor valor, más ancho de texto y menos hueco con la imagen.
                            flexBasis: { md: "calc(50% - 1.5rem)" },
                            maxWidth: { md: "calc(50% - 1.5rem)" },
                          }}
                        >
                          <Box
                            sx={{
                              maxWidth: "399px",
                              width: { xs: "300px", md: "80%" },
                              height: "auto",
                              aspectRatio: "1",
                              borderRadius: "399px",

                              marginBottom: { xs: "1rem", md: "128px" },
                              backgroundColor: "#EDEDED",
                              backgroundImage: `url("${section.image}")`,
                              backgroundSize: "cover",
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={6}
                          lg={6}
                          xl={6}
                          sx={{
                            // marginLeft negativo + flexBasis mayor: bloque de texto más ancho y menos separación respecto a la imagen.
                            marginLeft: { xs: 0, md: "-1.5rem" },
                            flexBasis: { md: "calc(50% + 1.5rem)" },
                            maxWidth: { md: "calc(50% + 1.5rem)" },
                          }}
                        >
                          <Box sx={{ width: "100%", maxWidth: "100%", boxSizing: "border-box" }}>
                            <Typography
                              fontSize="24px"
                              fontWeight={"bold"}
                              component={index == 1 && "h3"}
                            >
                              {section.title}
                            </Typography>
                            <Typography
                              fontSize="15px"
                              fontWeight={"bold"}
                              sx={{ color: "#6C6B70" }}
                            >
                              {section.subtitle}
                            </Typography>
                            <Box
                              sx={{
                                maxWidth: { xs: "100%", md: "100%" },
                                width: { md: "100%" },
                                mt: "1.5rem",
                                fontSize: "15px",
                                lineHeight: "21px",
                                color: "inherit",
                                "& p": {
                                  margin: 0,
                                  marginBottom: "1.1rem",
                                  "&:last-child": { marginBottom: 0 },
                                },
                                "& p strong.servicio-subtitulo": {
                                  display: "block",
                                  margin: 0,
                                  padding: 0,
                                  fontSize: { xs: "1.07em", sm: "1.12em" },
                                  lineHeight: 1.35,
                                  fontWeight: 700,
                                },
                              }}
                              dangerouslySetInnerHTML={{
                                __html: section.description.replaceAll("\n", "<br/>"),
                              }}
                            />
                          </Box>
                        </Grid>
                      </Grid>
                    )}
                    {index % 2 === 0 && index > 0 && (
                      <Grid container>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={6}
                          lg={6}
                          xl={6}
                          sx={{
                            order: { xs: "1", md: "0" },
                            justifyContent: { xs: "center", md: "flex-start" },
                            marginBottom: { xs: "50px", md: "0" },
                            paddingLeft: { xs: "0", md: "10%" },
                          }}
                        >
                          <Typography fontSize="24px" fontWeight={"bold"}>
                            {section.title}
                          </Typography>
                          <Typography fontSize="15px" fontWeight={"bold"} sx={{ color: "#6C6B70" }}>
                            {section.subtitle}
                          </Typography>
                          <Box
                            sx={{
                              maxWidth: { xs: "100%", md: "414px" },
                              mt: "1.5rem",
                              fontSize: "15px",
                              lineHeight: "21px",
                              color: "inherit",
                              "& p": {
                                margin: 0,
                                marginBottom: "1.1rem",
                                "&:last-child": { marginBottom: 0 },
                              },
                              "& p strong.servicio-subtitulo": {
                                display: "block",
                                margin: 0,
                                padding: 0,
                                fontSize: { xs: "1.07em", sm: "1.12em" },
                                lineHeight: 1.35,
                                fontWeight: 700,
                              },
                            }}
                            dangerouslySetInnerHTML={{
                              __html: section.description.replaceAll("\n", "<br/>"),
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={6}
                          lg={6}
                          xl={6}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            order: { xs: "0", md: "1" },
                            marginTop: { xs: "50px", md: "0" },
                            justifyContent: { xs: "center", md: "flex-start" },
                          }}
                        >
                          <Box
                            sx={{
                              maxWidth: "399px",
                              width: { xs: "300px", md: "80%" },
                              height: "auto",
                              aspectRatio: "1",
                              borderRadius: "399px",
                              marginY: "3rem",
                              backgroundColor: "#EDEDED",
                              backgroundImage: `url("${section.image}")`,
                              backgroundSize: "cover",
                            }}
                          />
                        </Grid>
                      </Grid>
                    )}
                  </>
                ))}
          </Box>

          {/* ── Metodología ── */}
          {(() => {
            const methodologyBlocks = (currentService.plantillaBlocks || [])
              .filter((b) => b.tipo === "metodologia")
              .sort((a, b) => a.pos - b.pos);
            if (methodologyBlocks.length === 0) return null;
            const methodologyHeader = methodologyBlocks[0];
            const methodologySteps = methodologyBlocks.slice(1);
            return (
              <Box
                component="section"
                sx={{
                  position: "relative",
                  marginTop: { xs: "3rem", md: "4rem" },
                  marginBottom: { xs: "2.5rem", md: "3rem" },
                  padding: { xs: "2.6rem 1rem 3.2rem", md: "2.85rem 2.6rem 3.35rem" },
                  borderRadius: "12px",
                  backgroundColor: "#F4F7F9",
                  overflow: "hidden",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    width: { xs: 18, md: 22 },
                    height: { xs: 18, md: 22 },
                    left: { xs: 12, md: 28 },
                    bottom: { xs: 22, md: 42 },
                    borderRadius: "50%",
                    backgroundColor: "#BAB5D5",
                    zIndex: 0,
                  },
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    width: { xs: 13, md: 16 },
                    height: { xs: 13, md: 16 },
                    left: { xs: 32, md: 54 },
                    bottom: { xs: 40, md: 62 },
                    borderRadius: "50%",
                    backgroundColor: "#586EAD",
                    zIndex: 0,
                  },
                }}
              >
                {/* Tres círculos decorativos superpuestos (arriba derecha), como la referencia visual. */}
                <Box
                  aria-hidden
                  sx={{
                    position: "absolute",
                    top: { xs: 10, md: 18 },
                    right: { xs: 10, md: 20 },
                    width: { xs: 88, md: 110 },
                    height: { xs: 56, md: 72 },
                    pointerEvents: "none",
                    zIndex: 0,
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: { xs: 4, md: 6 },
                      right: { xs: 36, md: 44 },
                      width: { xs: 22, md: 28 },
                      height: { xs: 22, md: 28 },
                      borderRadius: "50%",
                      backgroundColor: "#9DB4D4",
                      opacity: 0.65,
                    }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      top: { xs: 18, md: 24 },
                      right: { xs: 6, md: 8 },
                      width: { xs: 38, md: 48 },
                      height: { xs: 38, md: 48 },
                      borderRadius: "50%",
                      backgroundColor: "#C9B2C2",
                      opacity: 0.55,
                    }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      top: { xs: 0, md: 2 },
                      right: { xs: 0, md: 0 },
                      width: { xs: 34, md: 42 },
                      height: { xs: 34, md: 42 },
                      borderRadius: "50%",
                      backgroundColor: "#D9DBE1",
                      opacity: 0.75,
                    }}
                  />
                </Box>
                {/* Cabecera de metodología: conserva textos del CMS y solo adapta presentación. */}
                <Box
                  sx={{
                    position: "relative",
                    zIndex: 1,
                    textAlign: "center",
                    marginBottom: { xs: "2.1rem", md: "2.65rem" },
                  }}
                >
                  <Typography
                    component="h2"
                    sx={{
                      fontSize: { xs: "25px", sm: "31px", md: "34px" },
                      fontWeight: 700,
                      color: "#0F172A",
                      lineHeight: 1.2,
                      letterSpacing: "-0.02em",
                      marginBottom: "0.65rem",
                    }}
                  >
                    {methodologyHeader.title}
                  </Typography>
                  {methodologyHeader.subtitle && (
                    <Typography
                      sx={{
                        maxWidth: "940px",
                        marginX: "auto",
                        fontSize: { xs: "12.5px", md: "14px" },
                        color: "#424956",
                        lineHeight: 1.5,
                      }}
                    >
                      {methodologyHeader.subtitle}
                    </Typography>
                  )}
                </Box>
                <Grid
                  container
                  spacing={{ xs: 2.5, md: 3 }}
                  sx={{
                    position: "relative",
                    zIndex: 1,
                    width: "100%",
                    marginX: 0,
                  }}
                >
                  {methodologySteps.map((step, index) => (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      key={step.id || step.pos}
                      sx={{ position: "relative" }}
                    >
                      {index < methodologySteps.length - 1 && (
                        <Box
                          component="svg"
                          viewBox="0 0 37 37"
                          aria-hidden
                          sx={{
                            display: { xs: "none", md: "block" },
                            position: "absolute",
                            top: "49%",
                            right: "-22px",
                            width: 37,
                            height: 37,
                            transform: "translateY(-50%)",
                            zIndex: 2,
                          }}
                        >
                          <path
                            d="M7.6236 18.2966H28.9697M28.9697 18.2966L18.2967 7.62354M28.9697 18.2966L18.2967 28.9697"
                            stroke="#D1D5DC"
                            strokeWidth="3.04945"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </Box>
                      )}
                      <Box
                        sx={{
                          position: "relative",
                          minHeight: { xs: 224, md: 245 },
                          height: "100%",
                          padding: { xs: "1.65rem", md: "1.8rem 1.95rem" },
                          border: "none",
                          borderBottom: "4px solid #3F51B5",
                          borderRadius: "10px",
                          backgroundColor: "#FFF",
                          boxShadow: "0 2px 12px rgba(15, 23, 42, 0.07)",
                          overflow: "hidden",
                          isolation: "isolate",
                        }}
                      >
                        {/* Número grande de fondo: detrás del texto (z-index bajo + pointer-events none). */}
                        <Typography
                          component="span"
                          aria-hidden
                          sx={{
                            position: "absolute",
                            top: { xs: "2rem", md: "2.15rem" },
                            right: { xs: 2, md: 4 },
                            fontSize: { xs: "132px", md: "172px" },
                            fontWeight: 800,
                            color: "#D8DCE6",
                            opacity: 0.65,
                            lineHeight: 0.78,
                            zIndex: 0,
                            pointerEvents: "none",
                            userSelect: "none",
                          }}
                        >
                          {index + 1}
                        </Typography>
                        <Box
                          sx={{
                            position: "relative",
                            zIndex: 2,
                            width: { xs: 48, md: 54 },
                            height: { xs: 48, md: 54 },
                            borderRadius: "50%",
                            backgroundColor: "#3F51B5",
                            color: "#FFF",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: { xs: "18px", md: "21px" },
                            fontWeight: 700,
                            boxShadow: "0 4px 10px rgba(35, 58, 126, 0.24)",
                            marginBottom: { xs: "1.55rem", md: "2rem" },
                          }}
                        >
                          {index + 1}
                        </Box>
                        <Typography
                          component="h3"
                          sx={{
                            position: "relative",
                            zIndex: 2,
                            fontSize: { xs: "16px", md: "17px" },
                            fontWeight: 700,
                            color: "#0F172A",
                            marginBottom: "0.9rem",
                            lineHeight: 1.25,
                            textAlign: "left",
                          }}
                        >
                          {step.title}
                        </Typography>
                        <Typography
                          sx={{
                            position: "relative",
                            zIndex: 2,
                            fontSize: { xs: "12.5px", md: "13.2px" },
                            color: "#566070",
                            lineHeight: 1.55,
                            textAlign: "left",
                          }}
                        >
                          {step.description}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            );
          })()}

          {/* ── Beneficios ── */}
          {(() => {
            const benefitBlocks = (currentService.plantillaBlocks || [])
              .filter((b) => b.tipo === "beneficio")
              .sort((a, b) => a.pos - b.pos);
            if (benefitBlocks.length === 0) return null;
            const benefitHeader = benefitBlocks[0];
            const benefitItems = benefitBlocks.slice(1);
            const benefitIcons = [
              <Box
                key="success-rate"
                component="svg"
                viewBox="0 0 48 48"
                aria-hidden
                sx={{ width: 44, height: 44 }}
              >
                <path
                  d="M9 32L18 23L25 29L39 14"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="5"
                  strokeLinecap="square"
                  strokeLinejoin="miter"
                />
                <path
                  d="M29 14H39V24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="5"
                  strokeLinecap="square"
                  strokeLinejoin="miter"
                />
              </Box>,
              <Box
                key="cost-savings"
                component="svg"
                viewBox="0 0 73 73"
                aria-hidden
                sx={{ width: 45, height: 45 }}
              >
                <path
                  d="M47.2097 32.5817V32.6182M11.2845 22.9962C9.68108 21.7639 8.44961 20.1122 7.72621 18.2238C7.0028 16.3353 6.81562 14.2836 7.18535 12.2954C7.55509 10.3072 8.46735 8.45993 9.82129 6.95778C11.1752 5.45563 12.9182 4.35708 14.8574 3.78355C16.7967 3.21003 18.8567 3.18385 20.8099 3.70792C22.7631 4.23199 24.5334 5.28589 25.9251 6.75316C27.3168 8.22042 28.2756 10.0439 28.6958 12.0221C29.1159 14.0002 28.9809 16.056 28.3057 17.9623"
                  fill="none"
                  stroke="#4B5DA2"
                  strokeWidth="6.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M50.8655 6.9917V20.8946C55.3897 23.5128 58.8342 27.6559 60.5825 32.582H65.4849C66.4544 32.582 67.3843 32.9672 68.0699 33.6528C68.7555 34.3384 69.1406 35.2682 69.1406 36.2378V43.5493C69.1406 44.5189 68.7555 45.4488 68.0699 46.1344C67.3843 46.8199 66.4544 47.2051 65.4849 47.2051H60.5788C59.3505 50.6781 57.2631 53.7855 54.5176 56.2458V63.656C54.5176 65.1104 53.9398 66.5052 52.9114 67.5336C51.8831 68.5619 50.4883 69.1397 49.0339 69.1397C47.5796 69.1397 46.1848 68.5619 45.1564 67.5336C44.128 66.5052 43.5503 65.1104 43.5503 63.656V61.5247C42.3423 61.7278 41.1194 61.8293 39.8945 61.8282H25.2715C24.0465 61.8293 22.8237 61.7278 21.6157 61.5247V63.656C21.6157 65.1104 21.038 66.5052 20.0096 67.5336C18.9812 68.5619 17.5864 69.1397 16.1321 69.1397C14.6777 69.1397 13.2829 68.5619 12.2545 67.5336C11.2261 66.5052 10.6484 65.1104 10.6484 63.656V56.2458C7.33615 53.2845 5.00126 49.3872 3.95281 45.0696C2.90436 40.7521 3.19179 36.218 4.77704 32.0674C6.36228 27.9168 9.17061 24.3455 12.8303 21.8262C16.49 19.3068 20.8285 17.9583 25.2715 17.959H34.4109L50.8655 6.9917Z"
                  fill="none"
                  stroke="#4B5DA2"
                  strokeWidth="6.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </Box>,
              <Box
                key="brand-protection"
                component="svg"
                viewBox="0 0 48 48"
                aria-hidden
                sx={{ width: 42, height: 42 }}
              >
                <path
                  d="M24 7L38 12V22.4C38 31.2 32.5 38.5 24 42C15.5 38.5 10 31.2 10 22.4V12L24 7Z"
                  fill="currentColor"
                />
                <path
                  d="M17.5 24.5L22.2 29L31 19"
                  fill="none"
                  stroke="#F8F8F9"
                  strokeWidth="3.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </Box>,
              <Box
                key="commercial-relationship"
                component="svg"
                viewBox="0 0 72 46"
                aria-hidden
                sx={{ width: 45, height: 45 }}
              >
                <path
                  d="M26.6208 3.38634C22.3646 2.53159 17.9454 3.10406 14.0475 5.01507C10.1496 6.92608 6.99057 10.069 5.05967 13.9571C3.12878 17.8452 2.53375 22.2614 3.36675 26.5219C4.19975 30.7823 6.4143 34.6493 9.6674 37.5238C12.9205 40.3983 17.0307 42.12 21.3613 42.4222C25.6919 42.7243 30.0013 41.5902 33.6221 39.1953C37.2429 36.8005 39.973 33.2786 41.3897 29.1751C42.8063 25.0716 42.8304 20.6155 41.4582 16.497"
                  fill="none"
                  stroke="#4B5DA2"
                  strokeWidth="6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M45.1388 42.0868C49.3994 42.9459 53.8245 42.3744 57.7271 40.461C61.6297 38.5477 64.7915 35.3995 66.7217 31.5052C68.6519 27.6108 69.2425 23.1883 68.4018 18.9239C67.5611 14.6596 65.3362 10.7921 62.0724 7.92173C58.8086 5.05139 54.6885 3.33879 50.3517 3.04979C46.0149 2.76079 41.704 3.91156 38.0882 6.32345C34.4724 8.73534 31.754 12.2734 30.3549 16.3885C28.9558 20.5036 28.9543 24.9654 30.3507 29.0814"
                  fill="none"
                  stroke="#4B5DA2"
                  strokeWidth="6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </Box>,
            ];
            return (
              <Box
                component="section"
                sx={{
                  marginTop: { xs: "3rem", md: "3.75rem" },
                  marginBottom: { xs: "2rem", md: "3.15rem" },
                }}
              >
                {/* Título de beneficios: mantiene el contenido administrable desde el servicio. */}
                <Box sx={{ textAlign: "center", marginBottom: { xs: "1.75rem", md: "1.95rem" } }}>
                  <Typography
                    component="h2"
                    sx={{
                      fontSize: { xs: "25px", sm: "30px", md: "33px" },
                      fontWeight: 500,
                      color: "#171B22",
                      lineHeight: 1.18,
                      letterSpacing: "-0.018em",
                      marginBottom: benefitHeader.subtitle ? "0.75rem" : 0,
                    }}
                  >
                    {benefitHeader.title}
                  </Typography>
                  {benefitHeader.subtitle && (
                    <Typography
                      sx={{
                        maxWidth: "850px",
                        marginX: "auto",
                        fontSize: { xs: "14px", md: "15px" },
                        color: "#6C6B70",
                        lineHeight: 1.6,
                      }}
                    >
                      {benefitHeader.subtitle}
                    </Typography>
                  )}
                </Box>
                <Grid
                  container
                  sx={{
                    maxWidth: "1060px",
                    marginX: "auto",
                    backgroundColor: "#F8F8F9",
                    overflow: "hidden",
                  }}
                >
                  {benefitItems.map((benefit, index) => {
                    const benefitIcon = benefitIcons[index % benefitIcons.length];
                    return (
                      <Grid
                        item
                        xs={12}
                        md={6}
                        key={benefit.id || benefit.pos}
                        sx={{
                          borderRight: {
                            xs: "none",
                            md: index % 2 === 0 ? "1px solid #D6D8DE" : "none",
                          },
                          borderBottom: {
                            xs: index < benefitItems.length - 1 ? "1px solid #D6D8DE" : "none",
                            md:
                              index < benefitItems.length - (benefitItems.length % 2 || 2)
                                ? "1px solid #D6D8DE"
                                : "none",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "58px 1fr", sm: "88px 1fr" },
                            gap: { xs: "1rem", sm: "1.25rem" },
                            alignItems: "center",
                            minHeight: { xs: 150, md: 140 },
                            padding: { xs: "1.45rem 1.35rem", md: "1.55rem 2.35rem 1.45rem" },
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#3F55A6",
                            }}
                          >
                            <Box
                              sx={{
                                width: { xs: 44, md: 48 },
                                height: { xs: 44, md: 48 },
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {benefitIcon}
                            </Box>
                          </Box>
                          <Box>
                            <Typography
                              component="h3"
                              sx={{
                                fontSize: { xs: "16px", md: "18px" },
                                fontWeight: 700,
                                color: "#20242C",
                                lineHeight: 1.25,
                                marginBottom: "0.42rem",
                              }}
                            >
                              {benefit.title}
                            </Typography>
                            <Typography
                              sx={{
                                maxWidth: { md: "330px" },
                                fontSize: { xs: "13.5px", md: "14.2px" },
                                color: "#5C6370",
                                lineHeight: 1.38,
                              }}
                            >
                              {benefit.description}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
            );
          })()}
        </Container>
      </Box>

      {/* ── Testimonios ── */}
      {(() => {
        if (testimonios.length === 0) return null;
        const total = testimonios.length;
        const visible = Math.min(3, total);
        const items = Array.from(
          { length: visible },
          (_, i) => testimonios[(testimonioIdx + i) % total]
        );
        const canPrev = total > visible;
        const canNext = total > visible;
        return (
          <Box
            component="section"
            aria-labelledby="testimonios-heading"
            sx={{
              position: "relative",
              width: "100%",
              paddingBlockStart: { xs: "3.25rem", md: "2.65rem" },
              paddingBlockEnd: { xs: "4rem", md: "3.6rem" },
              overflow: "hidden",
              "& *": { fontFamily: "Roboto, sans-serif !important" },
              backgroundImage: [
                "linear-gradient(180deg, rgba(105, 44, 93, 0.96) 0%, rgba(82, 101, 166, 0.98) 100%)",
                "radial-gradient(circle at 16% 3%, rgba(158, 66, 128, 0.56) 0%, rgba(158, 66, 128, 0.18) 30%, transparent 58%)",
                "radial-gradient(circle at 82% 0%, rgba(35, 114, 125, 0.72) 0%, rgba(35, 114, 125, 0.22) 31%, transparent 58%)",
              ].join(", "),
              "&::before": {
                content: '""',
                position: "absolute",
                top: { xs: "-92px", md: "-160px" },
                left: "-9%",
                width: "118%",
                height: { xs: "184px", md: "268px" },
                background:
                  "linear-gradient(160deg, rgba(107, 32, 80, 0.98) 0%, rgba(129, 54, 93, 0.86) 48%, rgba(30, 112, 124, 0.88) 100%)",
                borderBottomLeftRadius: "50% 38%",
                borderBottomRightRadius: "54% 32%",
                transform: "rotate(-1.5deg)",
              },
              "&::after": {
                content: '""',
                position: "absolute",
                top: { xs: "-52px", md: "-88px" },
                left: "-13%",
                width: "126%",
                height: { xs: "148px", md: "192px" },
                background: "rgba(50, 68, 128, 0.5)",
                borderBottomLeftRadius: "42% 58%",
                borderBottomRightRadius: "58% 50%",
                transform: "rotate(3.5deg)",
              },
            }}
          >
            <Box
              sx={{
                position: "relative",
                zIndex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                maxWidth: "1180px",
                marginInline: "auto",
                paddingInline: { xs: "1rem", md: "2.1rem" },
              }}
            >
              {/* Cabecera alineada con referencia: pill RESEÑAS, título en una línea y texto introductorio debajo. */}
              <Box sx={{ textAlign: "center", marginBottom: { xs: "2rem", md: "2.1rem" } }}>
                {(() => {
                  const langIso =
                    idiomas.find((l) => l.id === Number(idioma))?.label?.toUpperCase() || "ES";
                  const isEn = langIso === "EN";
                  const serv = traducciones?.SERVICIO;
                  const badge = serv?.testimonios_badge || (isEn ? "REVIEWS" : "RESEÑAS");
                  const titleLine =
                    serv?.testimonios_titulo_completo ||
                    (isEn
                      ? "REAL TESTIMONIALS, HAPPY CLIENTS"
                      : "TESTIMONIOS REALES, CLIENTES FELICES");
                  const intro =
                    serv?.testimonios_intro ||
                    (isEn
                      ? "Here you can find some client reviews"
                      : "Aquí pueden encontrar algunas reseñas de clientes");
                  return (
                    <>
                      <Box
                        sx={{
                          display: "inline-block",
                          border: "1px solid rgba(255,255,255,0.75)",
                          borderRadius: "999px",
                          backgroundColor: "rgba(255,255,255,0.92)",
                          padding: "0.25rem 0.95rem",
                          marginBottom: "0.75rem",
                        }}
                      >
                        <Typography
                          sx={{
                            color: "#49567B",
                            fontSize: "10.5px",
                            fontWeight: 800,
                            letterSpacing: "0.08em",
                            textTransform: "uppercase",
                          }}
                        >
                          {badge}
                        </Typography>
                      </Box>
                      <Typography
                        id="testimonios-heading"
                        component="h2"
                        sx={{
                          color: "#FFF",
                          fontSize: { xs: "25px", sm: "30px", md: "31px" },
                          fontWeight: 500,
                          lineHeight: 1.2,
                          letterSpacing: "0.02em",
                          textTransform: "uppercase",
                          marginBottom: "0.65rem",
                        }}
                      >
                        {titleLine}
                      </Typography>
                      <Typography
                        component="p"
                        sx={{
                          color: "rgba(255,255,255,0.95)",
                          fontSize: { xs: "14px", md: "15px" },
                          fontWeight: 400,
                          lineHeight: 1.45,
                          maxWidth: "640px",
                          marginInline: "auto",
                          textTransform: "none",
                        }}
                      >
                        {intro}
                      </Typography>
                    </>
                  );
                })()}
              </Box>

              <Box
                role="region"
                aria-label="Carrusel de testimonios"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: { xs: "0.5rem", md: "1rem" },
                  width: "100%",
                }}
              >
                <Box
                  component="button"
                  type="button"
                  aria-label="Testimonio anterior"
                  disabled={!canPrev}
                  onClick={() => canPrev && setTestimonioIdx((prev) => (prev - 1 + total) % total)}
                  sx={{
                    flexShrink: 0,
                    width: { xs: 32, md: 44 },
                    height: { xs: 32, md: 44 },
                    minWidth: { xs: 32, md: 44 },
                    borderRadius: "50%",
                    border: "none",
                    backgroundColor: "transparent",
                    color: "#FFF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: canPrev ? "pointer" : "default",
                    fontSize: "1.375rem",
                    fontWeight: 300,
                    lineHeight: 1,
                    opacity: canPrev ? 1 : 0.4,
                    transition: "background-color 0.2s ease, opacity 0.2s ease",
                    "&:hover": canPrev ? { backgroundColor: "rgba(255,255,255,0.14)" } : {},
                  }}
                >
                  <ChevronLeftIcon />
                </Box>

                <Grid container spacing={{ xs: 2, md: 3 }} sx={{ flex: 1, minWidth: 0 }}>
                  {items.map((t, i) => (
                    <Grid item xs={12} md={4} key={`${t.ID}-${i}`}>
                      <Box
                        component="article"
                        sx={{
                          position: "relative",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          height: "100%",
                          backgroundColor: "#FFF",
                          borderRadius: "5px",
                          padding: { xs: "1.55rem", md: "1.85rem 1.75rem 1.7rem" },
                          minHeight: { xs: 205, md: 200 },
                          boxShadow: "0 8px 24px rgba(15, 23, 42, 0.1)",
                          overflow: "hidden",
                        }}
                      >
                        {/* Nombre del testimonio */}
                        <Typography
                          component="cite"
                          sx={{
                            fontSize: { xs: "15px", md: "15px" },
                            fontWeight: 700,
                            color: "#20232B",
                            fontStyle: "normal",
                            textAlign: "left",
                            marginBottom: "1rem",
                          }}
                        >
                          {t.NOMBRE}
                        </Typography>
                        {/* Texto del testimonio */}
                        <Typography
                          component="blockquote"
                          sx={{
                            flex: 1,
                            minHeight: 0,
                            margin: 0,
                            paddingRight: { xs: "2.6rem", md: "2.8rem" },
                            fontSize: { xs: "13px", md: "13.8px" },
                            color: "#606777",
                            lineHeight: 1.43,
                            textAlign: "left",
                          }}
                        >
                          &ldquo;{t.TEXTO}&rdquo;
                        </Typography>
                        <Box
                          component="svg"
                          viewBox="0 0 151 151"
                          aria-hidden
                          sx={{
                            position: "absolute",
                            right: { xs: 12, md: 14 },
                            bottom: { xs: 8, md: 10 },
                            width: { xs: 88, md: 102 },
                            height: { xs: 88, md: 102 },
                            opacity: 0.11,
                          }}
                        >
                          <path
                            d="M135.226 0H15.0252C6.76132 0 0 6.76132 0 15.0252V105.176C0 113.44 6.76132 120.201 15.0252 120.201H45.0755V142.739C45.0755 147.247 48.0805 150.252 52.5881 150.252H56.3443C57.8469 150.252 60.1006 149.5 61.6031 147.998L89.3997 120.201H135.226C143.49 120.201 150.252 113.44 150.252 105.176V15.0252C150.252 6.76132 143.49 0 135.226 0ZM67.6132 82.6384H37.5629V51.0855L47.3292 30.0503H62.3544L51.8368 52.5881H67.6132V82.6384ZM112.689 82.6384H82.6384V51.0855L92.4047 30.0503H107.43L96.9123 52.5881H112.689V82.6384Z"
                            fill="#535B9C"
                          />
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>

                <Box
                  component="button"
                  type="button"
                  aria-label="Testimonio siguiente"
                  disabled={!canNext}
                  onClick={() => canNext && setTestimonioIdx((prev) => (prev + 1) % total)}
                  sx={{
                    flexShrink: 0,
                    width: { xs: 32, md: 44 },
                    height: { xs: 32, md: 44 },
                    minWidth: { xs: 32, md: 44 },
                    borderRadius: "50%",
                    border: "none",
                    backgroundColor: "transparent",
                    color: "#FFF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: canNext ? "pointer" : "default",
                    fontSize: "1.375rem",
                    fontWeight: 300,
                    lineHeight: 1,
                    opacity: canNext ? 1 : 0.4,
                    transition: "background-color 0.2s ease, opacity 0.2s ease",
                    "&:hover": canNext ? { backgroundColor: "rgba(255,255,255,0.14)" } : {},
                  }}
                >
                  <ChevronRightIcon />
                </Box>
              </Box>
            </Box>
          </Box>
        );
      })()}

      {/* ── FAQ ── */}
      {(() => {
        // El primer bloque (menor pos) es la cabecera: TITULO = label, SUBTITULO = título de sección.
        // El resto son preguntas: TITULO = pregunta, DESCRIPCION = respuesta.
        const faqBlocks = (currentService.plantillaBlocks || [])
          .filter((b) => b.tipo === "faq")
          .sort((a, b) => a.pos - b.pos);
        if (faqBlocks.length === 0) return null;
        const faqHeader = faqBlocks[0];
        const faqItems = faqBlocks.slice(1);
        return (
          <Box
            sx={{
              position: "relative",
              backgroundColor: "#FFFFFF",
              width: "100%",
              paddingY: { xs: "3rem", md: "4.5rem" },
              overflow: "hidden",
            }}
          >
            <Box
              component="img"
              src={FaqSectionFigmaBg}
              alt=""
              aria-hidden
              sx={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "center top",
                pointerEvents: "none",
                zIndex: 0,
              }}
            />
            <Box
              sx={{
                position: "relative",
                zIndex: 1,
                maxWidth: "1140px",
                marginX: "auto",
                paddingX: { xs: "1.1rem", sm: "1.5rem", md: "2.25rem" },
              }}
            >
              {/*
                Figma: cabecera (pastilla + título + CTA) arriba a la izquierda; debajo, las
                preguntas en columna alineada a la derecha dejando margen vacío a la izquierda.
              */}
              <Box
                sx={{
                  marginBottom: 0,
                  textAlign: "left",
                  maxWidth: { xs: "100%", md: "min(100%, 520px)" },
                }}
              >
                <Box
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: 28,
                    border: "1px solid #415496",
                    borderRadius: "999px",
                    padding: "0.28rem 0.95rem",
                    marginBottom: "1.1rem",
                    backgroundColor: "#FFFFFF",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: 600,
                      color: "#415496",
                      lineHeight: 1.2,
                      letterSpacing: "0.01em",
                    }}
                  >
                    {faqHeader.title}
                  </Typography>
                </Box>
                <Typography
                  component="h2"
                  sx={{
                    fontSize: { xs: "1.375rem", sm: "1.625rem", md: "2rem" },
                    fontWeight: 700,
                    color: "#101828",
                    lineHeight: { xs: 1.2, md: 1.15 },
                    letterSpacing: "-0.02em",
                    marginBottom: "0.95rem",
                    overflowWrap: "anywhere",
                    wordBreak: "break-word",
                  }}
                >
                  {faqHeader.subtitle}
                </Typography>
                <Button
                  variant="contained"
                  href={`/${currentService.iso || "es"}/contacto/`}
                  sx={{
                    minWidth: { xs: "100%", sm: 168 },
                    maxWidth: { xs: "100%", sm: "none" },
                    width: { xs: "100%", sm: "auto" },
                    marginBottom: 0,
                    boxSizing: "border-box",
                    background:
                      "linear-gradient(90deg, #535B9C 0%, #7C527B 41.44%, #8F4F6C 77.74%, #A24B5D 100%)",
                    color: "#FFF",
                    borderRadius: "999px",
                    padding: "0.72rem 1.75rem",
                    textTransform: "none",
                    fontSize: "13px",
                    boxShadow: "none",
                    fontWeight: 600,
                    "&:hover": {
                      background:
                        "linear-gradient(90deg, #4a528d 0%, #6d486c 41.44%, #7f465f 77.74%, #8f4354 100%)",
                      boxShadow: "none",
                    },
                  }}
                >
                  {traducciones?.SERVICIO?.contactar_ahora || "Contactar Ahora"}
                </Button>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "stretch", md: "flex-end" },
                  width: "100%",
                  marginTop: {
                    xs: "1.125rem",
                    sm: "1rem",
                    md: "0.5rem",
                    lg: "-0.65rem",
                    xl: "-0.85rem",
                  },
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: { xs: "100%", md: "min(100%, 720px)" },
                    flexShrink: 0,
                  }}
                >
                  {faqItems.map((faq) => {
                    const faqKey = faq.id ?? faq.pos;
                    const isOpen = expandedFaq === faqKey;
                    return (
                      <Accordion
                        key={faqKey}
                        expanded={isOpen}
                        onChange={() => setExpandedFaq(isOpen ? null : faqKey)}
                        disableGutters
                        elevation={0}
                        sx={{
                          backgroundColor: "#FFF",
                          border: "1px solid #E2E5EB",
                          borderRadius: "8px !important",
                          marginBottom: "0.7rem",
                          overflow: "hidden",
                          boxShadow: "none",
                          "&:before": { display: "none" },
                        }}
                      >
                        <AccordionSummary
                          expandIcon={null}
                          sx={{
                            padding: { xs: "0.65rem 0.9rem", sm: "0 1rem", md: "0 1.2rem" },
                            minHeight: "unset",
                            borderBottom: isOpen ? "1px solid #ECEEF2" : "none",
                            "& .MuiAccordionSummary-content": {
                              alignItems: { xs: "flex-start", md: "center" },
                              justifyContent: "space-between",
                              gap: { xs: "0.65rem", md: "1rem" },
                              margin: { xs: "0.55rem 0", md: "0.8rem 0" },
                              overflow: "hidden",
                            },
                          }}
                        >
                          <Typography
                            sx={{
                              flex: "1 1 auto",
                              minWidth: 0,
                              fontSize: { xs: "0.9rem", sm: "15px", md: "15.5px" },
                              fontWeight: 700,
                              color: "#1B2230",
                              lineHeight: 1.45,
                              overflowWrap: "anywhere",
                              wordBreak: "break-word",
                              paddingRight: { xs: "0.25rem", md: 0 },
                            }}
                          >
                            {faq.title}
                          </Typography>
                          <Box
                            sx={{
                              width: 24,
                              height: 24,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                              color: "#6B7280",
                              marginTop: { xs: "0.1rem", md: 0 },
                            }}
                          >
                            {isOpen ? (
                              <CloseIcon sx={{ fontSize: "18px" }} />
                            ) : (
                              <AddIcon sx={{ fontSize: "18px" }} />
                            )}
                          </Box>
                        </AccordionSummary>
                        <AccordionDetails
                          sx={{
                            backgroundColor: "#FFF",
                            padding: {
                              xs: "0.65rem 0.9rem 1rem",
                              sm: "0.85rem 1rem 1.2rem",
                              md: "0.9rem 1.2rem 1.25rem",
                            },
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: { xs: "0.8125rem", sm: "13px", md: "13.5px" },
                              color: "#6B7280",
                              lineHeight: 1.65,
                              overflowWrap: "anywhere",
                              wordBreak: "break-word",
                            }}
                          >
                            {faq.description}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    );
                  })}
                </Box>
              </Box>
            </Box>
          </Box>
        );
      })()}

      {/* Más soluciones */}
      <Box
        sx={{ background: "#F7F8FA", color: "#222", "& *": { fontFamily: "Nunito !important" } }}
      >
        <Container
          sx={{
            paddingTop: { xs: "3.5rem", md: "4rem" },
            paddingBottom: "72px",
            background: "#F7F8FA",
            maxWidth: {
              xl: "1320px!important",
              lg: "1140px!important",
              md: "100%!important",
              sm: "100%!important",
              xs: "100%!important",
            },
          }}
        >
          {/* Más soluciones */}
          <Grid container sx={{ textAlign: "center" }}>
            <Grid item xs={12}>
              <Typography
                gutterBottom
                fontSize={"40px"}
                sx={{ lineHeight: "1", color: "#01101D", fontWeight: "bold" }}
                component={"h2"}
              >
                Nuestros servicios
              </Typography>
              <Typography fontSize={"16px"} sx={{ color: "#666666" }}>
                {traducciones && traducciones.SERVICIO.Mas_soluciones_text}
              </Typography>
            </Grid>
            <Grid item xs={12} mt={"3rem"}>
              <Grid container rowGap={"1rem"} gap={"1rem"} justifyContent={"center"}>
                {visibleServices.map((key) => (
                  <Grid
                    item
                    key={key.title}
                    xs={12}
                    sm={12}
                    md={3}
                    lg={3}
                    xl={3}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ServiceCardSmall
                      title={key.title}
                      url={key.url}
                      seoURLFriendly={key.seoURLFriendly}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Box
                component="section"
                sx={{
                  position: "relative",
                  marginTop: { xs: "4rem", md: "5.5rem" },
                  padding: { xs: "3.5rem 1rem", md: "4.3rem 1rem 5.1rem" },
                  overflow: "hidden",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    right: { xs: "-92px", md: "-34px" },
                    top: { xs: "-54px", md: "-38px" },
                    width: { xs: 190, md: 260 },
                    height: { xs: 190, md: 260 },
                    borderRadius: "50%",
                    backgroundColor: "#E9EAF2",
                  },
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    left: { xs: "-110px", md: "-78px" },
                    bottom: { xs: "-112px", md: "-82px" },
                    width: { xs: 205, md: 225 },
                    height: { xs: 205, md: 225 },
                    borderRadius: "50%",
                    backgroundColor: "#EFF1F6",
                  },
                }}
              >
                <Box
                  aria-hidden
                  sx={{
                    position: "absolute",
                    left: { xs: "1rem", md: "1.7rem" },
                    top: { xs: "2.2rem", md: "2.7rem" },
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    backgroundColor: "#9AA8CA",
                  }}
                />
                <Box sx={{ position: "relative", zIndex: 1 }}>
                  <Typography
                    gutterBottom
                    component="h2"
                    sx={{
                      color: "#181D27",
                      fontSize: { xs: "32px", md: "44px" },
                      fontWeight: 700,
                      lineHeight: 1.05,
                      letterSpacing: "-0.02em",
                      marginBottom: "0.75rem",
                    }}
                  >
                    {traducciones && traducciones.SERVICIO.demo_form_title}
                  </Typography>
                  <Typography
                    sx={{
                      color: "#626B79",
                      fontSize: { xs: "15px", md: "16px" },
                      lineHeight: 1.4,
                    }}
                  >
                    {traducciones && traducciones.SERVICIO.demo_form_subtitle}
                  </Typography>
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: { xs: "2rem", md: "2.8rem" },
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        maxWidth: "600px",
                        minHeight: { xs: "auto", md: "480px" },
                        padding: { xs: "2rem 1.35rem", md: "2.65rem 2.7rem" },
                        backgroundColor: "#FFF",
                        border: "1px solid #DDE1E8",
                        borderRadius: "9px",
                        boxShadow: "0 2px 7px rgba(15, 23, 42, 0.05)",
                        textAlign: "left",
                        "& .MuiGrid-container": {
                          rowGap: "0.25rem",
                        },
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#F4F5F7 !important",
                          borderRadius: "4px",
                          minHeight: "42px",
                        },
                        "& .MuiFilledInput-root:hover": {
                          backgroundColor: "#F4F5F7 !important",
                        },
                        "& .MuiFilledInput-root.Mui-focused": {
                          backgroundColor: "#F4F5F7 !important",
                        },
                        "& .MuiInputBase-input": {
                          color: "#5E6674",
                          fontSize: "14px !important",
                          padding: "13px 18px !important",
                        },
                        "& textarea.MuiInputBase-input": {
                          minHeight: "46px !important",
                          padding: "0 !important",
                        },
                        "& form > .MuiGrid-container > .MuiGrid-item:nth-of-type(3) > .MuiBox-root":
                          {
                            justifyContent: "flex-start",
                          },
                        "& .MuiFormControlLabel-root": {
                          marginTop: "0.75rem",
                          marginLeft: 0,
                          alignItems: "center",
                        },
                        "& .MuiCheckbox-root": {
                          padding: "4px 8px 4px 0",
                          color: "#D3D6DD",
                        },
                        "& .MuiTypography-root": {
                          color: "#606977",
                        },
                        "& button[type='submit']": {
                          width: "158px",
                          height: "39px",
                          marginTop: "-0.2rem",
                          borderRadius: "999px !important",
                          background: "linear-gradient(90deg, #4F5AA7 0%, #A24162 100%) !important",
                          fontSize: "13px",
                          fontWeight: 500,
                        },
                      }}
                    >
                      <ContactForm rightAligned={false} />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <FrontOfficeFooter />
    </>
  );
}
export default ServiciosDetailPage;
